import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/asset/importer/assetImporterActions';

export default importerReducers(actions);
